// TODO:FFW-78 対応完了後、このcomponentを削除する
import styled from '@emotion/styled';
import type { HTMLAttributes } from 'react';

const StyledDiv = styled.div`
  padding: 3px 3px 3px 3px;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  align-content: center;
  justify-content: center;
  width: 100%;
`;

function CenterAlignedButtonGroup(props: HTMLAttributes<HTMLDivElement>) {
  const { className, children } = props;

  return <StyledDiv className={`button-group ${className ? className : ''}`}>{children}</StyledDiv>;
}

export { CenterAlignedButtonGroup };
